import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider as ReduxProvider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import './assets/styles/index.scss';
import ErrorBoundary from './components/ErrorBoundary';
import NotificationManager from './components/Notification';
import ModalRootComponent from './components/modals/ModalRootComponent';
import { AuthProvider } from './contexts/AuthContext';
import { LocalizationProvider } from './contexts/LocalizationContext';
import store from './redux/store';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <StrictMode>
  <ErrorBoundary>
    <BrowserRouter basename={window._env.basePath || '/'}>
      <ReduxProvider store={store}>
        <AuthProvider>
          <LocalizationProvider>
            <ModalRootComponent />
            <NotificationManager />
            <App />
          </LocalizationProvider>
        </AuthProvider>
      </ReduxProvider>
    </BrowserRouter>
  </ErrorBoundary>
  // </StrictMode>
);
